import React from 'react';

import { LoadingOverlay } from '../components/LoadingOverlay';

interface ExternalRedirect {
  to: string;
}

export const ExternalRedirect: React.FC<ExternalRedirect> = ({ to }) => {
  window.location.replace(to);

  return <LoadingOverlay loading />;
};
